/**
 * Internal dependencies
 */
import BlockMenu from './block-menu';
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class BlockMenuManager {

	/**
	 * @type Document
	 */
	contextDocument = document;

	/**
	 * @type BlockMenu[]
	 */
	blockMenuList = [];

	/**
	 * @type String
	 */
	blockMenuSelector = '.block-menu';

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		document.addEventListener( 'WMUViewportChange', this.onViewportChange );
	}

	/**
	 * 
	 */
	clear()
	{
		this.blockMenuList.forEach( ( blockMenu ) =>
		{
			blockMenu.clear();
		} );

		this.blockMenuList = [];
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	setup( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = this.contextDocument;
		}

		contextElement.querySelectorAll( this.blockMenuSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuBlockMenu )
			{
				const blockMenu = new BlockMenu( element );
				blockMenu.setup();
				this.blockMenuList.push( blockMenu );
			}
		} );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockMenuManager;